import { enqueueSnackbar } from "notistack";
import { clearStorage } from "../ayudas/GlobalData";

const UNDEFINED_RESPONSE = "No response was received";
const NO_DATA = "No data results";
const WITHOUT_RESULT = "without history version";
const INVALID_LOGIN = "Invalid username or/and password";
//const SESSION_EXPIRED = "The session has expired, please log in again";
const TIME_INVALID_SCHEDULED = "The schedule must be at least 10 minutes apart";
const DeletePack = "The requested package has been removed or is not available";
export async function getMsg(response) {
  let msg = undefined;
  if (response && response["OK"] === true) {
    msg = response["msg"];
  } else {
    setError(response);
  }

  return msg;
}
export async function getMsgDash(response, textTitleDash) {
  let msg = undefined;
  if (response && response["OK"] === true) {
    msg = response["msg"];
  } else {
    setError(response, textTitleDash);
  }

  return msg;
}

export async function getMsgResult(response, successMessage) {
  let msgResult = undefined;
  if (response && response["OK"] === true) {
    if (response["msg"]["query"]) {
      msgResult = response["msg"]["result"];
    }
    if(successMessage){
      enqueueSnackbar(successMessage,{variant:"success"});
    }

  } else {
    setError(response);
  }

  return msgResult;
}
export async function getMsgResultText(response) {
  let msgResult = undefined;
  if (
    response["status"] === 200 ||
    response["status"] === 201 ||
    response["status"] === 202 ||
    response["status"] === 203
  ) {
    msgResult = response;
  } else {
    setError(response);
  }

  return msgResult;
}
export async function getMsgResultIOC(response) {
  let msgResult = undefined;
  if (response && response["OK"] === true) {
    if (response["msg"]) {
      msgResult = response["msg"];
    }
  } else {
    setError(response);
  }

  return msgResult;
}
export async function getMsgResultClients(response) {
  let msgResult = undefined;
  if (response && response["OK"] === true) {
    if (response["msg"]["query"]) {
      msgResult = response["msg"]["result"];
    } else {
      enqueueSnackbar(WITHOUT_RESULT,{variant:"error"});
      msgResult = false;
    }
  } else {
    setError(response);
  }
  return msgResult;
}

export async function getResultAndShowSuccess(response, successMessage) {
  let isSuccessResponse = false;
  if (response && response["OK"] === true) {
    if (response["msg"]["query"]) {
      isSuccessResponse = response["msg"]["query"];
    } else if (response["msg"] === "unverified") {
      isSuccessResponse = false;
    } else {
      isSuccessResponse = response["msg"];
    }
  }

  if (isSuccessResponse) {
    enqueueSnackbar(successMessage,{variant:"success"});
  } else {
    setError(response);
  }

  return isSuccessResponse;
}

export function getResult(response) {
  let isSuccessResponse = false;
  if (response && response["OK"] === true) {
    isSuccessResponse = response["msg"]["query"];
  } else {
    setError(response);
  }
  return isSuccessResponse;
}

export function getResultAuth(response) {
  let isSuccessResponse = false;
  if (response && response["OK"] === true) {
    isSuccessResponse = response["msg"]["query"];
  } else {
    setError(response);
  }

  return { isSuccessResponse: isSuccessResponse, response: response };
}

export function getResponse(response) {
  let returnResponse = undefined;
  if (response && response["OK"] === true) {
    returnResponse = response;
  } else {
    setError(response);
  }
  return returnResponse;
}
export function getResponseText(response) {
  let returnResponse = undefined;
  if (response && response["status"] === 200) {
    returnResponse = response;
  } else {
    setError(response);
  }
  return returnResponse;
}
export function getResponseValidate(response) {
  let returnResponse = undefined;
  if (response && response["OK"] === true) {
    if (response["msg"] === "unverified") {
      setError(response);
    }
    returnResponse = response;
  } else {
    setError(response);
  }
  return returnResponse;
}

export function setError(response, textTitle = "") {
  
  let errorMessage = "";

  errorMessage = response ? "" : "undefinedResponse";
  let licenseError = response?.msg ? response.msg : "";
  if (errorMessage === "") {
    errorMessage =
      typeof response.msg?.query === "boolean" && response.msg?.query === false
        ? response.msg?.result
        : "";
  }

  if (errorMessage === "") {
    errorMessage = typeof response["msg"] === "string" ? response["msg"] : "";
  }

  if (errorMessage === "") {
    errorMessage =
      typeof response.msg?.msg === "string" ? response.msg?.msg : "";
  }
  switch (errorMessage) {
    case "Bad authentication":
      enqueueSnackbar(INVALID_LOGIN,{variant:"error"});
      break;

    case "Undefined or incorrect authentication email":
      enqueueSnackbar(INVALID_LOGIN,{variant:"error"});
      break;

    case "Invalid Token":
      expiredSession();
      break;

    case "undefinedResponse":
      enqueueSnackbar(UNDEFINED_RESPONSE,{variant:"error"});
      break;

    case "Without results":
      enqueueSnackbar(textTitle + " " + NO_DATA,{variant:"info"});
      break;

    case "The date is less than allowed":
      enqueueSnackbar(TIME_INVALID_SCHEDULED,{variant:"info"});
      break;

    case "The required value of id is incorrect or undefined":
      enqueueSnackbar(DeletePack,{variant:"info"});
      break;
    case "TOTP is wanted, add the generated value of authPayload":
      enqueueSnackbar("The Two Factor Activated Required Code Verify",{variant:"info"});
      break;

    case "unverified":
      enqueueSnackbar("User Not Verified Correct QR in APP",{variant:"error"});
      break;

    case "verified":
      enqueueSnackbar("Activation Of Two-factor Authentication Successful",{variant:"success"});
      break;

    case "Invalid request: AuthPayload is required":
      enqueueSnackbar("Code Verification is Required",{variant:"warning"});
      break;

    case "Invalid request: AuthPayload is too short, minimum length should be 3":
      enqueueSnackbar(
        "Code Verification is too short, the minimum required is 3"
        ,{variant:"warning"});
      break;

    case "Max limit of 100 totp factors associated per entity reached":
      enqueueSnackbar(
        "Max limit 100 of request factors associated per entity reached"
        ,{variant:"error"});
      break;

    case "Invalid request: AuthPayload type must be numeric":
      enqueueSnackbar("The verification code must be only numerical digits",{variant:"error"});
      break;

    case "Invalid request: AuthPayload is too long, maximum length should be 8":
      enqueueSnackbar(
        "Code Verification is too long, maximum length should be 8"
        ,{variant:"warning"});
      break;

    case "Invalid or incorrect authPayload":
      enqueueSnackbar("Invalid or Incorrect Code of Verification",{variant:"warning"});
      break;

    case "The required value of language is incorrect or undefined":
      enqueueSnackbar("Language is Required",{variant:"warning"});
      break;

    case "The required value of description is incorrect or undefined":
      enqueueSnackbar("Description is required",{variant:"warning"});
      break;

    case "The required value of platform is incorrect or undefined":
      enqueueSnackbar("Platform is Required",{variant:"warning"});
      break;

    case "The required value of name is incorrect or undefined":
      enqueueSnackbar("Name is Required",{variant:"warning"});
      break;
    case "No files uploaded":
      enqueueSnackbar("This Code is Required",{variant:"warning"});
      break;
    case "Failed to generate history":
      enqueueSnackbar("Failed to generate history report",{variant:"warning"});
      break;
    case "No license or configuration":
      enqueueSnackbar("No license or configuration",{variant:"warning"});
      break;
    case "Execution request not sent, client without insolation activated":
      enqueueSnackbar(
        "Execution request not sent, client without insolation activated"
        ,{variant:"warning"});
      break;
    case "Execution request not sent, client has an active execution process":
      enqueueSnackbar(
        "Execution request not sent, client has an active execution process"
        ,{variant:"warning"});
      break;
    case "The current password is incorrect":
      enqueueSnackbar("The current password is incorrect",{variant:"warning"});
      break;

    case "Unidentified Agent":
      break;

    case "Email already registered":
      enqueueSnackbar("Can't create a new user because it's already registered",{variant:"error"});
      break;

    default:
      console.error(errorMessage);
  }
  if (licenseError !== "" && licenseError === "Expired license") {
    clearStorage();
    window.location.reload();
    sessionStorage.setItem("LicenseExpired", true);
  }
}

export function expiredSession() {
  clearStorage();
  window.location.reload();
}
